import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { NotificationService } from "../services/notification.service";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ApiService } from "../services/api.service";
import { Router } from "@angular/router";
import { Message } from "../class/message";
import { Routes } from "../constants/routes";
import { AuthenticationService } from "../services/authentication.service";
import { ToastrService } from "ngx-toastr";
import { ErrorCode } from "../constants/error-code";
import { RestApi } from "../models/rest-api.model";
import { AuthService } from "../auth/auth.service";
import { TimeoutSessionService } from "../services/timeout-session.service";
import { SsoLoginWarningComponent } from "src/app/shared/components/sso-login-warning/sso-login-warning.component";
import { MatDialog } from "@angular/material";
import { Location } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { ErrorComponent } from "src/app/shared/components/error/error.component";

/**
 * The request handler interceptor
 */
export class RequestHandlerInterceptor implements HttpInterceptor {
  /**
   *
   */
  @BlockUI() blockUI: NgBlockUI;
  public href = "";
  /**
   * The permission url.
   */
  private PERMISSION_URL = "/auth/permission-info";
  /**
   * Check start block screen
   */
  private started = false;
  /**
   * array requested api
   */
  private requestedApiWait: any = [];
  /**
   * array api alow block screen
   */
  private loadingUrls: string[] = [
    "/config-general/create",
    "/home-enterprise/digital-certificate-person",
    "/customer/detail",
    "/file/upload/excel/add-customer",
    "/file/excel/template-add-customer",
    "/customer/filter",
    "/customer/add",
    "/customer/edit",
    "/enterprises",
    "/enterprises/filter",
    "/enterprises/tenantId",
    "/enterprises/change-status",
    "/enterprises/branchs/filter",
    "/enterprises/branch/",
    "/enterprises/branch/parentId",
    "/enterprises/child/parentId",
    "/enterprises/change-status",
    "/enterprises/branchs/filte",
    "/users/group-user",
    "/users/user-enterprise",
    "/users/user-enterprise/search",
    "/users/user-admin/search",
    "/users/user-detail",
    "/users/user-change-status",
    "/users/user-enterprise",
    "/users/reset-password",
    "/features",
    "/feature-groups",
    "/auth/login",
    "/file/upload/enterprises",
    "/file/upload/customer",
    "/file/download/enterprises",
    "/file/download/customer",
    "/users/user-detail",
    "/file/viewDocTypePdf",
    "/document-type/filter",
    "/document-type/sub/filter",
    "/common/auto-complete/auto-complete?filter=",
    "/document-type/change-status",
    "/document-type/set-auto-sign",
    "/enterprise/document-type/filter",
    "/enterprise/document-type/sub/filter",
    "/enterprise/document-type/change-status",
    "/enterprise/document-type",
    "/enterprise/document-type/set-auto-sign",
    "/enterprise/document-type",
    "/file/view/contract",
    "/contract/filter",
    "/contract/sub/filter",
    "/contract/file",
    "/file/viewDocTypeEtpHtml",
    "/file/viewDocTypeHtml",
    "/contract/side-take/filter",
    "/contract/sub/side-take/filter",
    "/contract/delete",
    "/contract/reject",
    "/contract/submit",
    "/file/viewDocTypeEtpHtml",
    "/digital-certificate/filter",
    "/digital-certificate/view",
    "/digital-certificate/change-status",
    "/digital-certificate/create",
    "/customer/attachment",
    "/contract/relation",
    "/contract",
    "users/signers",
    "/common/item-type/enterprise-type",
    "/common/service-type/detail",
    "/digital-signature/otp/generate-transaction",
    "/digital-signature/sign/otp",
    "/digital-signature/sign/server-signature",
    "/hsm/hsm-sign",
    "/digital-certificate/otp/generate-transaction",
    "/digital-certificate/otp/confirm",
    "/digital-certificate/create",
    "/contract/wait-sign/all",
    "/digital-certificate/get-certificate-simca",
    "/digital-signature/sign/sim-ca",
    "/digital-certificate/get-certificate-usbtoken",
    "/digital-signature/generate-hash",
    "/digital-signature/sign/usb-token",
    "/auth/forgot-password",
    "/file/upload/contractAttachment",
    "/common/auto-complete/customer?filter=",
    "/common/docs-type",
    "/digital-certificate/get-certificate",
    // '/file/download/sign-plugin',
    "/file/download-last-version?os=WINDOWS&typeFile=exe",
    "/users/change-password",
    "/document-verify",
    "/document-verify/verify",
    "/service-types/get-all",
    "/service-types/create",
    "/service-types/edit",
    "/service-types/update",
    "/service-types/delete",
    "/users/change-password",
    "/auth/permission-info",
    "/digital-signature/sign/image-without-certificate-directly",
    "/digital-signature/sign/image-without-certificate",
    "/digital-certificate/update-image",
    "/digital-certificate/create-with-image",
    "/anonymous/login",
    "/anonymous/file-detail",
    "/anonymous/detail",
    "/anonymous/negotiate/form/update",
    "/anonymous/get-certificate-simca",
    "/anonymous/sign-simca-no-image",
    "/anonymous/sign-simca-image",
    "/anonymous/generate-hash-no-image",
    "/anonymous/sign-usb-token",
    "/anonymous/download-plugins",
    "/anonymous/generate-hash-image",
    "/anonymous/declined-document",
    "/anonymous/check-status",
    "/anonymous/sign/otp-no-image-multi-pos",
    `/anonymous/sign/otp-image-multi-pos`,
    `/auto-sign/contract-queue/dispatchAction`,
    `/auto-sign/contract-queue/dispatchAction`,
    `/dc/document-type-enterprises/get-all`,
    `/dc/document-type-enterprises/save`,
    `/dc/document-type-enterprises/get-by-id/`,
    `/dc/document-type-enterprises/delete/`,
    `/dc/document-type-enterprises/copy/`,
    `/dc/template-files/get-all`,
    `/dc/template-files/save-all`,
    `/dc/template-files/delete-all`,
    `/dc/files/save-all`,
    `/dc/files/get-content-by-url`,
    `/dc/data-types/get-all`,
    `/dc/field-types/get-all`,
    `/dc/fixed-functions/get-all`,
    `/dc/categories/get-all`,
    `/dc/category-fields/get-all`,
    `/dc/field-configs/save-all`,
    `/dc/field-configs/delete-all`,
    `/dc/template-field-configs/get-all`,
    `/dc/template-field-configs/save-all`,
    `/dc/template-field-configs/delete-all`,
    `/dc/document-type-enterprises/generate-form/`,
    `/dc/files/merge-data-to-file`,
    `/enterprises/dc-enterprise/`,
    `/dc/files/merge-data-to-file`,
    `/dc/document-type-enterprises/check-permission`,
    `/master-data-types/get-all`,
    `/master-data-types/delete/`,
    `/master-data-types/create`,
    `/master-data-types/update`,
    `/master-data/check-delete-relation/`,
    `/dc/signatures/save-all`,
    `/dc/files/convert-docx-to-pdf`,
    `/dc/files/get-content-template-by-url`,
    "/procedure/create",
    "/procedure/search-details",
    "/procedure/check-customer-user",
    "/procedure/edit",
    "/anonymous/files-detail-no-filepath",
    "/file/view/contract-files/",
    // '/digital-signature/sign/cancel',
    "/anonymous/sign/cancel",
    "/cp-info/get-all",
    "/cp-info/",
    "/cp-info/update",
    "/cp-info/create",
    "/cp-info/get-by-id/",
    `/dc/document-type-enterprises/check-permission`,
    `/verify-account/sign-sim-ca`,
    `/verify-account/sign-usb-token`,
    `/verify-account/ekyc`,
    `/verify-account/sign-cloud-ca`,
    "/ekyc/verify-ekyc",
    "/ekyc/validate-ekyc-otp-support",
    "/ekyc/sign-ekyc-support/image-without-certificate-mobile-multi-pos",
    `/dc/document-type-enterprises/get-signatures-positions/`,
    "/digital-certificate/get-cert-cloud-ca",
    "anonymous/certs-cloud-ca",
    "/digital-certificate/default/filter",
    "/digital-certificate/update-certificate-default",
    "/file-scope/upload/excel/add-user",
    "/file-scope/excel/template-add-user",
    "digital-signature/sign-multi-cloud-ca",
    "digital-signature/sign-approve-multi-cloud-ca",
    "/digital-signature/cancel-process",
    `/digital-signature/cancel-approve-process?type=2`,
    `/digital-signature/cancel-approve-process?type=3`,
    "/digital-signature/sign-approve-multi-no-certified",
    "/address",
    "/external-system/",
    "digital-certificate/sign-admin",
    "/verify-account/generate-hash",
    "/digital-certificate/synchronize-cert-cloud-ca",
    "/verify-account/generate-hash-no-position",
    "/generate-image",
  ];

  private cancelHandleErrors: string[] = [
    "/ekyc/validate-ekyc-otp-support",
    "/ekyc/sign-ekyc-support/image-without-certificate-mobile-multi-pos",
    "/sign/cloud-ca-no-image-multiple-pos",
    "/sign/cloud-ca-image-multiple-pos",
    "/contract-employment/sign-and-approve",
    "/contract-employment/sign/usb-token",
    "/digital-signature/generate-hash-image",
    "/digital-signature/generate-hash-no-image",
    "/sign/sim-ca-no-image-multiple-pos",
    "/sign/sim-ca-image-multiple-pos",
    "/anonymous/sign-cloud-ca-no-image",
    "/anonymous/sign-cloud-ca-image",
    "/anonymous/sign-simca-no-image-multi-pos",
    "/anonymous/sign-simca-image-multi-pos",
    "/file/download/pre-multiple-contract-files-zip",
    "/file/download/pre-multiple-contract-digital-files-zip",
    "/generate-image",
    "/config-general/create",
    "/service-types/update",
    "/contract/check-permission-create-contract",
    "/auth/login",
    "/common/get-cert-cloud-ca",
    "/anonymous/verify-two-factor-external",
    "/verify-account/verify-two-factor-internal",
    "/verify-account/get-result-verify-two-factor",
    "/vneid/agent-init/share-info",
    "/verify-account/face-match/vneid",
    "/verify-account/share-info/vneid",
    "/verify-account/face-match/verify-sign-vneid",
    "/verify-account/share-info/verify-sign-vneid",
    "/verify-account/verify-and-update/vneid",
    "/verify-account/validate-face-match",
  ];
  private errorCodeMustHandle: string[] = [ErrorCode.NoAccessToContracts];

  private ignoreUrls: string[] = [
    // config doanh nghiệp + resources: chỉ đọc, sidebar/dashboard tự quản loading
    "/enterprises/configs/",
    "/enterprises/resources/",
    // AI
    "/customer/gen-file-customer",
    // Add document (Upload) -> search with document type parent
    "/contract/parent-name-and-docs-type",
    "/contract/parent-by-name",
    // Document type management -> load child document type
    "/enterprise/document-type/sub/filter",
    // System Document type management -> load child document type
    "/document-type/sub/filter",
    // Document management -> load child document
    "/contract/sub/filter/",
    // '/auth/forgot-password',
    // Dashboard analysis-report: dùng skeleton cục bộ thay BlockUI toàn màn hình
    "/contract/user-statistic",
    "/analysis/consumption",
    "/enterprises/enterprise-by-service",
    "/contract-lot/get-all-processing",
    "/digital-signature/sign/server-signature-no-image-multi-pos",
    "/digital-signature/sign/server-signature-image-multi-pos",
    "/digital-signature/sign/sim-ca-image-multiple-pos",
    "/digital-signature/sign/sim-ca-no-image-multiple-pos",
    "/digital-signature/sign/usb-token-multi-pos",
    "/digital-signature/sign/otp-image-multi-pos",
    "/digital-signature/sign/otp-no-image-multi-pos",
    "/anonymous/generate-hash-image",
    // '/anonymous/generate-hash-no-image',
    "/anonymous/sign-usb-token",
    "/anonymous/sign-simca-no-image-multi-pos",
    "/anonymous/sign-simca-image-multi-pos",
    "/anonymous/sign/otp-image-multi-pos",
    "/anonymous/sign/otp-no-image-multi-pos",
    "/anonymous/sign/image-without-certificate-multi-pos",
    "/digital-signature/generate-hash-image",
    // '/digital-signature/generate-hash-no-image',
    "/contract-lot/get-by-id/",
    "/digital-signature/sign/image-without-certificate-multi-pos",
    "/digital-certificate/change-default-status",
    // '/digital-signature/generate-hash-no-image',
    "/enterprises/search/enterprise-tenant",
    // digital_contract
    "/contract/digital/filter-contract-parent-by-name-or-code",
    "/digital-signature/sign-batch/usb-token-multi-pos",
    "/enterprises/filter-enterprise-service-type",
    "/common/auto-complete/sign/contract-share/user-department",
  ];

  // noBlockUI: string = "/contract/negotiate/get-comment";
  noBlockUI = [
    '/contract/negotiate/get-comment',
    '/auth/login-by-vneid',
  ];
  private blockUIPermissionTimer;

  constructor(
    public notificationService: NotificationService,
    private apiService: ApiService,
    private router: Router,
    private message: Message,
    private auth: AuthenticationService,
    private authService: AuthService,
    private toastr: ToastrService,
    private timeoutSessionService: TimeoutSessionService,
    public dialog: MatDialog,
    private location: Location,
    private translateService: TranslateService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const jwtStart = new Date();
    if (
      request.responseType === "json" &&
      !request.url.split("/").includes("i18n")
    ) {
      request = request.clone({
        withCredentials: true,
        responseType: "text",
      });
    }
    const isNoBlockUI = this.noBlockUI.some(url =>
      request.url.includes(url)
    );
    // check if url request with array api alow block screen
    // X-Silent-Loading: request background tu component tu quan ly loading rieng -> khong block UI
    if (this.isLoading(this.fixUrl(request.url)) && request.headers.get("X-Silent-Loading") !== "1") {
      // check stop this.blockUIPermissionTimer
      if (this.blockUIPermissionTimer != null) {
        clearTimeout(this.blockUIPermissionTimer);
        this.blockUIPermissionTimer = null;
      }

      this.requestedApiWait.push(request.url);
      if (!this.started && !isNoBlockUI) {
        this.blockUI.reset();
        this.blockUI.start("");
        this.started = true;
      }
    }

    return next
      .handle(request)
      .pipe(
        map((event) => {
          let clonedEvent: any = event;
          // Try to decode the result from server
          try {
            const token =
              this.authService.getToken() ||
              this.authService.getAnonymousToken();
            if (token && token.length > 0) {
              const encodedToken = btoa(token);
              clonedEvent.body = clonedEvent.body.replace(encodedToken, "");
            }
            clonedEvent = clonedEvent.clone({
              body: JSON.parse(
                clonedEvent.body
                  ? this.b64DecodeUnicode(clonedEvent.body)
                  : clonedEvent.body
              ),
            });
            if (!request.url.endsWith("lasted")) {
            }
            clonedEvent.body.data = JSON.parse(clonedEvent.body.data);
          } catch (e) {}
          if (clonedEvent instanceof HttpResponse) {
            const index: number = this.requestedApiWait.indexOf(request.url);
            if (index !== -1) {
              this.requestedApiWait.splice(index, 1);
            }
            // this.requestedApiWait.pop(request.url);
            // Handle to start sprint loading
            if (
              this.isLoading(clonedEvent.url) &&
              !clonedEvent.url.includes(this.PERMISSION_URL)
            ) {
              // && !this.router.isActive('/home-enterprise/main', true)) {
              if (this.requestedApiWait.length === 0) {

                this.stopBlockUI();
              }
            }

            if (clonedEvent.url.includes(this.PERMISSION_URL)) {
              // 300ms la du de che khoang guard resolve -> page mount goi API dau tien (F5);
              // sau khi pre-call permission-info tai login, timer nay gan nhu khong con chay
              this.blockUIPermissionTimer = setTimeout(() => {
                this.stopBlockUI();
                this.blockUIPermissionTimer = null;
              }, 300);
            }
          }
          // this.notificationService.setErrorCode('');
          return clonedEvent;
        }),
        catchError((error) => {
          if (error instanceof HttpErrorResponse) {
            const index: number = this.requestedApiWait.indexOf(request.url);
            if (index !== -1) {
              this.requestedApiWait.splice(index, 1);
            }

            // unauthorized request
            // if (error.status === 401) {
            //   this.auth.logout();
            //   this.stopBlockUI();
            //   this.router.navigate(['/enterprise-login']);
            //   this.notificationService.notify(this.message.getMessage('messages.exprise'));
            //   return throwError(error.error);
            // }

            if (this.isLoading(error.url)) {
              this.stopBlockUI();
            } else {
              //               console.log('isLoading: false', error.url);
            }
            let errorMessage = "";
            if (error.error instanceof ErrorEvent) {
              // client-side error
              // errorMessage = `Error: ${error.error.message}`;
              errorMessage = error.error.message;
            } else {
              errorMessage = error.message;
            }

            if (error.status === 429) {
              this.toastr.error(
                this.message.getMessage("messages.api_rate_limit")
              );
              this.router.navigate(["/api-rate-limit"]);
              // window.location.href = "error";
            }
            // session expired
            if (error.status === 401) {
              this.href = this.router.url;
              if (this.href == "/reset-password") {
                this.toastr.error(this.message.getMessage("messages.exprise"));
              }
              this.stopBlockUI();
              if (
                this.href.includes(Routes.ENTERPRISE_HOME) ||
                this.href === "/reset-password"
              ) {
                this.router.navigate(["enterprise-login"]).then(() => {
                  this.auth.logout();
                });
              } else {
                this.checkOldOrNewAnonymousLink();
              }
              this.auth.logout();
              this.notificationService.notify(
                this.message.getMessage("messages.exprise")
              );
              window.location.reload();
              return throwError(error.error);
              // const errorMessageDecode = JSON.parse((error && error.error) ? this.b64DecodeUnicode(error.error) : error.error);
              // if (errorMessageDecode) {
              //   this.toastr.error(errorMessageDecode.message);
              //   return throwError(errorMessageDecode.message);
              // }
            }
            const checkUrlRequest =
              request.url.includes("sign/sim-ca-no-image-multiple-pos") ||
              request.url.includes("sign/sim-ca-image-multiple-pos") ||
              request.url.includes("sign/cloud-ca-no-image-multiple-pos") ||
              request.url.includes("sign/cloud-ca-image-multiple-pos")
                ? false
                : true;
            if (
              !request.url.includes("sign/get-sign-transaction-result") &&
              checkUrlRequest
            ) {
              this.notificationService.notify(
                this.message.getMessage("messages.error_message")
              );
            }
            this.notificationService.setErrorCode(error.error);
            return throwError(
              !request.url.includes("sign/get-sign-transaction-result")
                ? errorMessage
                : ""
            );
          }
        })
      )
      .pipe(
        map((event: HttpEvent<any>) => {
          this.apiService.event = event;
          let errorMessage = "";
          if (event instanceof HttpResponse) {
            if (
              window.sessionStorage.getItem("token") ||
              (window.sessionStorage.getItem("tenantId") &&
                window.localStorage.getItem("SignDataValidate"))
            ) {
              this.timeoutSessionService.start(jwtStart);
            }
            if (event.body.success === false) {
              // account not verify
              if (event.body.code === ErrorCode.AccountNotVerify  && !request.url.includes('check-limit-verify-vneid')) {
                this.checkOldOrNewAnonymousLink();
                this.auth.logout();
                return false;
              }
              // If error code is unauthorized
              if (event.body.code === ErrorCode.UnAuthorized) {
                this.checkOldOrNewAnonymousLink();
                this.auth.logout();
                this.notificationService.notify(
                  this.message.getMessage("messages.exprise")
                );
                return throwError(errorMessage);
              }
              // if (event.body.code === ErrorCode.ResetPasswordSuccess) {
              //   this.router.navigate(['/enterprise-login']);
              //   this.toastr.success(this.message.getMessage('alert.reset_password_success'));
              //   return throwError(errorMessage);
              // }
              if (event.body.code === ErrorCode.HashKeyNotExist) {
                this.router.navigate(["404"]);
                return throwError(errorMessage);
              }
              if (event.body.code === ErrorCode.ContractExpireTime) {
                // this.router.navigate(['/expire']);
                window.location.href = "expire";
                return false;
              }
              if (
                event.body.code === ErrorCode.NoAccessToContracts &&
                window.location.pathname !==
                  "/home-enterprise/search-approval-waiting-document"
              ) {
                // this.router.navigate(['/error']);
                window.location.href = "error";
                return false;
              }
              if (event.body.code === ErrorCode.HashKeyExpired) {
                this.router.navigate(["/reset-password-exists"]);
                return throwError(errorMessage);
              }
              if (event.body.code === ErrorCode.accountLock) {
                this.toastr.error(event.body.message);
                return throwError(errorMessage);
              }
              if (
                event.body.message &&
                event.body.message.includes("user_service not found")
              ) {
                this.toastr.error(
                  this.translateService.instant(
                    "digital_contract.error.not_service"
                  )
                );
                this.router.navigate(["/enterprise-login"]);
                return throwError(errorMessage);
              }

              if (event.body.code === ErrorCode.PasswordExpired) {
                // debugger
                if (this.router.url !== "/reset-password") {
                  this.router.navigate(["/reset-password"]);
                }
                return throwError(errorMessage);
              }

              // debugger;
              // ocsp toast message
              if (
                event.body.code === ErrorCode.CheckCertOCSPLostConnection ||
                event.body.code === ErrorCode.CheckCertOcspNoSupport ||
                event.body.code === ErrorCode.OCSPNoSupport ||
                event.body.code === ErrorCode.CertificateNoCA ||
                event.body.code === ErrorCode.ResetPasswordSuccess ||
                event.body.code === ErrorCode.SignButNotConnectOcsp
              ) {
                if (
                  this.router.url !== "/home-enterprise/digital-certificate"
                ) {
                  this.toastr.error(event.body.message);
                }
              }

              // sso login warning message
              if (event.body.code === ErrorCode.SsoLoginCode) {
                const dialogRe = this.dialog.open(SsoLoginWarningComponent, {
                  width: "500px",
                  data: this.message.getMessage("messages.sso_notify"),
                });
                dialogRe.afterClosed().subscribe((rs) => {
                  if (rs) {
                    window.location.href = rs;
                    dialogRe.close();
                  }
                });
              }
              if (
                event.body.code === ErrorCode.GetTokenFromSSO ||
                event.body.code === ErrorCode.GetDataFromSSO ||
                event.body.code === ErrorCode.CerficicateNoError ||
                event.body.code === ErrorCode.UserDisableAdmin ||
                event.body.code === ErrorCode.UserNotFound
              ) {
                this.toastr.error(event.body.message);
                this.router.navigate(["enterprise-login"]).then(() => {
                  this.auth.logout();
                });
              }

              if (event.body.code === ErrorCode.HasApproval) {
                this.router.navigate(["/approval/success"]);
              }
              if (event.body.code === ErrorCode.HasRejectApproval) {
                this.router.navigate(["/approval/reject"]);
              }
              // //Nếu là lỗi không có quyền xem tài liệu thì xử lý không hiện thông báo ToastrService nữa !!!
              // if (event.body.code === ErrorCode.NoAccessToContracts) {
              //   this.notificationService.setAvailableNoAccess(event.body.code);
              //   return throwError(errorMessage);
              // }

              // session expired
              if (event.body.code === ErrorCode.SessionExpired) {
                this.href = this.router.url;
                if (this.href.includes(Routes.ENTERPRISE_HOME)) {
                  this.router.navigate(["enterprise-login"]).then(() => {
                    this.auth.logout();
                  });
                } else {
                  this.checkOldOrNewAnonymousLink();
                }
                // console.log('logout 4444444444444444444444444444');
                this.auth.logout();
                this.toastr.error(
                  this.message.getMessage("messages.expired_date")
                );
                window.location.reload();
              }
              if (
                this.apiService.shoudIngoreHanldingError(
                  new RestApi(request.method, request.url)
                )
              ) {
                // let caller handle this error
                return event;
              }
              if (
                this.isCancelHandleErrors(this.fixUrl(request.url)) &&
                !this.errorCodeMustHandle.includes(event.body.code)
              ) {
                return event;
              }
              switch (event.body.code) {
                // If code is duplicate version, which is 0x00122, return data to handle on api service
                case ErrorCode.UnAuthorized:
                case ErrorCode.TaxCodeDuplicate:
                case ErrorCode.PasswordInvalid:
                case ErrorCode.CertificateCodeDuplicate:
                case ErrorCode.DocumentsDuplicate:
                case ErrorCode.MissingRequiredContractFields:
                case ErrorCode.ServiceTypeHasContract:
                case ErrorCode.DuplicateServiceName:
                case ErrorCode.DuplicateServiceCode:
                case ErrorCode.EmptyImportExcel:
                case ErrorCode.FormatImportExcel:
                case ErrorCode.OutOfMoneyOtp:
                case ErrorCode.ContactSystemAdmin:
                case ErrorCode.NotPermissionForm:
                case ErrorCode.CopyNotPermission:
                case ErrorCode.ExportGroupCustomerNotFound:
                case ErrorCode.ExportGroupCustomerNotPermission:
                case ErrorCode.ExportCustomerNotPermission:
                case ErrorCode.ExportCustomerNotFound:
                case ErrorCode.BranchNotPermission:
                case ErrorCode.NotPermissionOnDocumentType:
                case ErrorCode.GroupUserNotBelong:
                case ErrorCode.GroupUserServiceTypeDeleted:
                case ErrorCode.GroupUserDepartmentDeleted:
                case ErrorCode.GroupUserNoCreateSideDocumentPermission:
                case ErrorCode.GroupUserServiceTypeAndDataPermissionNotMatch:
                case ErrorCode.GroupUserServiceTypeNotPermission:
                case ErrorCode.GroupUserDataPermissionNotPermission:
                case ErrorCode.GroupUserDataPermissionNotFound:
                case ErrorCode.GroupUserNotPermission:
                case ErrorCode.ContractExist:
                case ErrorCode.NotPermissionOnBranch:
                case ErrorCode.NotPermissionOnUser:
                case ErrorCode.AccountVerify:
                case ErrorCode.AccountVerifyFailed:
                case ErrorCode.ResetPasswordSuccess:
                case ErrorCode.ContactTemplateHasContract:
                case ErrorCode.ContactTemplateHasContractAndTemplate:
                case ErrorCode.DocumentTemplateCodeExist:
                case ErrorCode.FileContentIsDenied:
                case ErrorCode.DocumentInactive:
                case ErrorCode.DocumentNotExist:
                case ErrorCode.CannotDecode:
                case ErrorCode.NotPermissionTemplate:
                case ErrorCode.WarningOutOfContractQuantity:
                case ErrorCode.ConfigTemplate:
                case ErrorCode.MasterDataBlock:
                case ErrorCode.MasterDataDocumentTemplateBlock:
                case ErrorCode.MasterDataTypeDocumentTemplateBlock:
                case ErrorCode.DataNotfound:
                case ErrorCode.MasterDataNotfound:
                case ErrorCode.FieldIsDeleted:
                case ErrorCode.CategoryIsDeleted:
                case ErrorCode.RefCategoryIsDeleted:
                case ErrorCode.MasterDataTypeDuplicateName:
                case ErrorCode.MasterDataTypeNotFound:
                case ErrorCode.MergeFieldAlreadyExist:
                case ErrorCode.MergeFieldError:
                case ErrorCode.FormatImportCustomerExcel:
                case ErrorCode.EmptyImportCustomerExcel:
                case ErrorCode.FormatImportExcelError:
                case ErrorCode.EmptyFileImportExcelError:
                case ErrorCode.TemplateNotForLot:
                case ErrorCode.CheckCertOCSPLostConnection:
                case ErrorCode.CheckCertExpriredError:
                case ErrorCode.SignHashFileError:
                case ErrorCode.IsHasSignProcess:
                case ErrorCode.CertificateWrongError:
                case ErrorCode.CertificateNoCA:
                case ErrorCode.OCSPNoSupport:
                case ErrorCode.ValidateCTSNumber:
                case ErrorCode.ValidateName:
                case ErrorCode.ProcedureNameExisted:
                case ErrorCode.ErrorImageRecognition:
                case ErrorCode.OtpNotSupport:
                case ErrorCode.DepartmentCodeExist:
                case ErrorCode.DepartmentNameExist:
                case ErrorCode.BothDepartmentCodeAndNameExist:
                case ErrorCode.DepartmentLockError:
                case ErrorCode.DepartmentUnlockError:
                case ErrorCode.UpdateUserErrorRepresentativeExist:
                case ErrorCode.AssignRepresentativeNotFound:
                case ErrorCode.AssignRepresentativeInactive:
                case ErrorCode.DepartmentDeletedOrLocked:
                case ErrorCode.isContractProcess:
                case ErrorCode.CodeCPMatched:
                case ErrorCode.UserMatchedEnterprise:
                case ErrorCode.CPIsDeletedOrBlock:
                case ErrorCode.CPCanNotDelete:
                case ErrorCode.CPCanNotUpdate:
                case ErrorCode.NotPermissionChangeDefaultCert:
                case ErrorCode.AddUserDepartmentInactive:
                case ErrorCode.AssignRepresentativeAlready:
                case ErrorCode.CreateUpdateDigitalContract1:
                case ErrorCode.CreateUpdateDigitalContract2:
                case ErrorCode.CreateUpdateDigitalContract3:
                case ErrorCode.CreateUpdateDigitalContract4:
                case ErrorCode.CreateUpdateDigitalContract5:
                case ErrorCode.CreateUpdateDigitalContract6:
                case ErrorCode.CreateUpdateDigitalContract7:
                case ErrorCode.CreateUpdateDigitalContract8:
                case ErrorCode.CreateUpdateDigitalContract9:
                case ErrorCode.CreateUpdateDigitalContract10:
                case ErrorCode.CreateUpdateDigitalContract11:
                case ErrorCode.CreateUpdateDigitalContract12:
                case ErrorCode.InBackupTime:
                case ErrorCode.ActiveContract:
                case ErrorCode.ActiveContract1:
                case ErrorCode.ActiveContract2:
                case ErrorCode.ParentContractCanNotDelete:
                case ErrorCode.UserInactive:
                case ErrorCode.ContractSuccess:
                case ErrorCode.NotFoundDataReport:
                case ErrorCode.ErrorGetData:
                case ErrorCode.DuplicateProcess:
                case ErrorCode.LotNotFound:
                case ErrorCode.NotEnoughMoneyTimestamp:
                case ErrorCode.ExistType:
                case ErrorCode.NoExistValue:
                case ErrorCode.SignTransactionRetryCECAFalse:
                case ErrorCode.SignTransactionRetryMOITFalse:
                case ErrorCode.SignTransactionDuplicate:
                case ErrorCode.FalseToReTry:
                case ErrorCode.DataNotExist:
                case ErrorCode.Property1:
                case ErrorCode.Property2:
                case ErrorCode.DocumentGroup:
                case ErrorCode.NotEnoughMoneyEnterprise:
                case ErrorCode.SignUsbTokenFail:
                // case ErrorCode.SignUserNotManageCertificate:
                case ErrorCode.OtpNotFoundSubjectConfirm:
                case ErrorCode.RetryExpiredMOIT:
                case ErrorCode.SignTransactionFailedToResetDown:
                case ErrorCode.ContractNotExistToSave:
                case ErrorCode.TemplateNotActiveOrDeleted:
                case ErrorCode.TransactionResetFailed:
                case ErrorCode.CloudCa:
                case ErrorCode.MaxLengthCa:
                case ErrorCode.DuplicateCa:
                case ErrorCode.ErrorCa:
                case ErrorCode.DuplicateSystemCode:
                case ErrorCode.Permission:
                case ErrorCode.UploadFileSms:
                case ErrorCode.GroupCustomerExisted:
                case ErrorCode.CustomerNotExisted:
                case ErrorCode.GroupCustomerRemoved:
                case ErrorCode.GroupCustomerDeleted:
                case ErrorCode.ErrorInUpdateCustomer:
                case ErrorCode.ErrorInUpdateCustomer1:
                case ErrorCode.ErrorInUpdateCustomer2:
                case ErrorCode.ErrorInUpdateCustomer3:
                case ErrorCode.ErrorInUpdateCustomer4:
                case ErrorCode.ErrorInUpdateCustomer5:
                case ErrorCode.CheckMaxApprover:
                case ErrorCode.CustomerIdentityOtpOutOfMoney:
                case ErrorCode.isNotAutoContract:
                case ErrorCode.ExistSignature:
                case ErrorCode.MaxSizeError:
                case ErrorCode.SmsWarningClient:
                case ErrorCode.SmsWarningUser:
                case ErrorCode.VerifyEnterprise:
                case ErrorCode.NotChangeContractCode:
                case ErrorCode.RefusedIdentify:
                case ErrorCode.BusinessesRunOutOfMoneySMS:
                case ErrorCode.Identify:
                case ErrorCode.NotPermissionWithContract:
                case ErrorCode.SendLinkContract:
                case ErrorCode.DeleteDepartmentNormal:
                case ErrorCode.DeleteDepartmentDigital:
                case ErrorCode.DeleteUserNormal:
                case ErrorCode.DeleteUserDigital:
                case ErrorCode.ForwardSignFailed:
                case ErrorCode.HasApproval:
                case ErrorCode.HasRejectApproval:
                case ErrorCode.GroupUserDataNormal:
                case ErrorCode.GroupUserDataDigital:
                case ErrorCode.GroupUserDataNotFoundNormal:
                case ErrorCode.GroupUserDataNotFoundDigital:
                case ErrorCode.FirstTimePassSamePassword:
                case ErrorCode.CloudCAConnectFail:
                case ErrorCode.OtpNotFoundSubjectConfirmKycSContract:
                case ErrorCode.Account_No_Subscribe_File_Download_Capacity_resource:
                case ErrorCode.Account_Subscribe_File_Download_Capacity_resource:

                case ErrorCode.GenDataCustomerFromFile:
                case ErrorCode.GenDataImageBase64NotEmty:
                case ErrorCode.GenDataListTypeDocumentNotEmty:
                case ErrorCode.GenDataTypeCustomerInvalid:
                case ErrorCode.CancelSignFlowWithContract:
                case ErrorCode.BlockUserConfigNotification:
                case ErrorCode.RESET_OTP_CUSTOMER_NOT_IN_SIGN_FLOW:
                case ErrorCode.OTP_EXCEED_SENDING_LIMIT:
                case ErrorCode.NOT_IP_CONFIG:
                case ErrorCode.IP_ALLOWED_IP_EXPORT:
                case ErrorCode.IP_ALLOWED_IP_IMPORT_OVER:
                case ErrorCode.CLOUD_CA_USER_NOT_EXIST:
                case ErrorCode.CLOUD_CA_REQUEST_NOT_EXIST:
                case ErrorCode.CLOUD_CA_TRANSACTION_NOT_EXIST:
                case ErrorCode.CLOUD_CA_REQUEST_TIMEOUT:
                case ErrorCode.CLOUD_CA_USER_UNAUTHORISED:
                case ErrorCode.CLOUD_CA_USER_NOT_SUFFICIENT:
                case ErrorCode.CLOUD_CA_USER_NOT_ACCEPTED:
                case ErrorCode.CLOUD_CA_USER_INVALID:
                case ErrorCode.CLOUD_CA_INTERNAL_SERVER_ERROR_CERT:
                case ErrorCode.IP_ALLOWED_REGEX_IP_INVALID:
                case ErrorCode.IP_ALLOWED_IP_DUPPLICATE:
                case ErrorCode.TWO_FACTOR_AUTHEN_TIME_OUT:
                case ErrorCode.TWO_FACTOR_CERTIFICATE_INVALID:
                case ErrorCode.CERTIFICATE_USER_NO_MAXLENGTH:
                case ErrorCode.CERTIFICATE_USER_ID_INVALID:
                case ErrorCode.TOKEN_AUTHEN_TWO:
                case ErrorCode.CLOUD_CA_USER_CERTIFICATE_NOT_EXIST:
                case ErrorCode.CLOUD_CA_INTERNAL:
                case ErrorCode.CLOUD_CA_INTERNAL_EX:
                case ErrorCode.CLOUD_CA_INTERNAL_EX1:
                case ErrorCode.CLOUD_CA_DEVICE_EXPIRE:
                case ErrorCode.CLOUD_CA_INTERNAL_EX2:
                case ErrorCode.CLOUD_CA_INTERNAL_EX3:
                case ErrorCode.CLOUD_CA_ORTHER_EX:
                case ErrorCode.CLOUD_CA_EXPIRED:
                case ErrorCode.CLOUD_CA_NOT_FOUND:
                case ErrorCode.CLOUD_CA_CONTACT_ADMIN:
                case ErrorCode.GROUP_CUSTOMER_DOES_NOT_EXIST:
                case ErrorCode.RECORDS_COUNT_EXCEEDED:
                case ErrorCode.GOOGLE_LOGIN_ACCOUNT_HAS_LINKED:
                case ErrorCode.GOOGLE_LOGIN_APP_PARAM_INVALID:
                case ErrorCode.GOOGLE_LOGIN_EMAIL_EXIST:
                case ErrorCode.GOOGLE_LOGIN_REFERENCE_INVALID:
                case ErrorCode.GOOGLE_LOGIN_TOKEN_INVALID:
                case ErrorCode.GOOGLE_LOGIN_USER_INVALID:
                case ErrorCode.DUPLICATE_CERTIFICATENO:
                case ErrorCode.DOCUMENT_ERROR:
                case ErrorCode.EXPIRED_CONTRACT_1MB:
                case ErrorCode.DUPLICATE_CUSTOMER:
                case ErrorCode.QUICKLY_CONTRACT_PERMISSION:
                case ErrorCode.PIN_REQUIRED:
                case ErrorCode.SERIAL_REQUIRED:
                case ErrorCode.OUT_OF_RESOURCES_10MB:
                case ErrorCode.SOCIAL_LOGIN_ACCOUNT_HAS_LINKED:
                case ErrorCode.SOCIAL_LOGIN_EMAIL_EXIST:
                case ErrorCode.SOCIAL_LOGIN_REFERENCE_INVALID:
                case ErrorCode.SOCIAL_LOGIN_TOKEN_INVALID:
                case ErrorCode.SOCIAL_LOGIN_USER_INVALID:
                case ErrorCode.SIGN_MULTI_NOT_FOUND_CONTRACT_DIGITAL_VALID:
                case ErrorCode.SIGN_DIGITAL_MULTI_USB_TOKEN_NUMBER_FILE_INVLAID:
                case ErrorCode.SIGN_DIGITAL_MULTI_CLOUD_CA_NUMBER_FILE_INVLAID:
                case ErrorCode.FILE_PDF_ERRROR:
                case ErrorCode.NOT_CREATE_LOT_DOCUMENT:
                case ErrorCode.ERROR_USERNAME:
                case ErrorCode.ERROR_EMAIL:
                case ErrorCode.ERROR_VERIFY_CODE:
                case ErrorCode.EXPIRED_VERIFY_CODE:
                case ErrorCode.RequestError:
                case ErrorCode.WrongInfor:
                case ErrorCode.NOT_HAVE_MULTILPE_USER:
                case ErrorCode.ACCOUNT_NOT_CF:
                case ErrorCode.RESOURCE_QUANTITY_CHANGED:
                case ErrorCode.RESOURCE_EXPIRED:
                case ErrorCode.ENTERPRISE_NOT_EXIST:
                case ErrorCode.ADMIN_FOR_ASSISTAN:
                case ErrorCode.AUTHEN_FAIL:
                case ErrorCode.ONLY_SUPPORT_SCONTRACT:
                case ErrorCode.VNEID_EXCEPTION:
                case ErrorCode.VNEID_VALIDATE_DESCRIPTION_EXCEPTION:
                case ErrorCode.VNEID_VERIFY_EXCEPTION:
                case ErrorCode.VNEID_VERIFY_BAD_REQUEST_EXCEPTION:
                  // case ErrorCode.NoAccessToContracts:
                  return event;
                default:
                  // console.log(event.body);

                  if (
                    event.body.code === ErrorCode.SsoLoginCode &&
                    !event.body.success
                  ) {
                    return null;
                  }
                  const checkUrlRequest =
                    request.url.includes("sign/sim-ca-no-image-multiple-pos") ||
                    request.url.includes("sign/sim-ca-image-multiple-pos") ||
                    request.url.includes(
                      "sign/cloud-ca-no-image-multiple-pos"
                    ) ||
                    request.url.includes("sign/cloud-ca-image-multiple-pos")
                      ? false
                      : true;
                  errorMessage =
                    event.body.message == null && checkUrlRequest
                      ? this.message.getMessage("messages.error_message")
                      : `${event.body.message}
                  `; // Enter new line
                  for (const key in event.body.data) {
                    if (event.body.data.hasOwnProperty(key)) {
                      const value = event.body.data[key];
                      errorMessage += `${value}
                    `; // Enter new line
                    }
                  }
                  // localStorage.setItem('error_code_document', event.body.code);
                  if (
                    event.body.code !== ErrorCode.NoAccessToContracts &&
                    !request.url.includes("sign/get-sign-transaction-result")
                  ) {
                    this.notificationService.notify(errorMessage);
                  }
                  this.notificationService.setErrorCode(event.body.code);
                  if (
                    event.body.data != null &&
                    (event.body.code === "0x00110" ||
                      event.body.code === "0x002100")
                  ) {
                    localStorage.setItem("count_login_failed", event.body.data);
                  }
                  return throwError(
                    !request.url.includes("sign/get-sign-transaction-result")
                      ? errorMessage
                      : ""
                  );
              }
            }
          }
          // this.notificationService.notify('');
          return event;
        })
      ) as any;
  }

  // get url
  private fixUrl(url: string) {
    if (url.indexOf("http://") >= 0 || url.indexOf("https://") >= 0) {
      return url;
    } else {
      return this.apiService.getBaseUrl() + url;
    }
  }

  // check url in array api ignore or alow block screen
  private isLoading(inUrl: string): boolean {
    let isloading = false;
    for (let i = 0; i < this.ignoreUrls.length; i++) {
      if (inUrl.indexOf(this.ignoreUrls[i]) !== -1) {
        return false;
      }
    }

    for (let j = 0; j < this.loadingUrls.length; j++) {
      if (inUrl.indexOf(this.loadingUrls[j]) !== -1) {
        isloading = true;
        break;
      }
    }
    return isloading;
  }

  private isCancelHandleErrors(inUrl: string): boolean {
    let isCancelErrors = false;
    for (let j = 0; j < this.cancelHandleErrors.length; j++) {
      if (inUrl.indexOf(this.cancelHandleErrors[j]) !== -1) {
        isCancelErrors = true;
        break;
      }
    }
    return isCancelErrors;
  }

  // Decoding base64 ⇢ UTF8
  private b64DecodeUnicode(str) {
    return decodeURIComponent(
      Array.prototype.map
        .call(atob(str), (c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  }

  /**
   * Stop block UI.
   */
  private stopBlockUI() {
    const urltest = this.router.url;
    this.blockUI.stop();
    this.started = false;
  }

  private startBlockUI() {
    this.blockUI.start();
    this.started = true;
  }

  private checkOldOrNewAnonymousLink() {
    this.href = this.router.url;
    const regxAnonymousUrl = /\/sign-anonymous\/.+\/.+\//gm;
    const regxAnonymousUrlNew = /\/sign-anonymous\/.+\/.+\/.+\//gm;
    const regxKYCCustom = /\/kyc-customer-identify\/.+\/.+\//gm;
    const regxKYCCamera = /\/kyc-camera-anonymous\/.+\/.+\//gm;
    const regxKYCSign = /\/kyc-sign-anonymous\/.+\/.+\//gm;
    const regxKYC = /\/kyc-confirm-account-anonymous\/.+\/.+\//gm;
    const regxIentifi = /\/identification-method\/.+\/.+\//gm;
    const newUrl = regxAnonymousUrl.exec(this.href);
    const newUrlAnonymousLogin = regxAnonymousUrlNew.exec(this.href);
    const urlKYCCustom = regxKYCCustom.exec(this.href);
    const urlKYCCamera = regxKYCCamera.exec(this.href);
    const urlKYCSign = regxKYCSign.exec(this.href);
    const urlKYC = regxKYC.exec(this.href);
    const urlKYCIentifi = regxIentifi.exec(this.href);
    if (this.href.includes("sign-anonymous")) {
      let urlLogin = "";
      if (newUrl.length > 0 && !newUrlAnonymousLogin) {
        // urlLogin = decodeURIComponent(newUrl[0]);
        if (
          this.href.includes("/detail") ||
          this.href.split("/sign").length - 1 == 2
        ) {
          if (this.href.split("/").length - 1 == 4) {
            urlLogin = decodeURIComponent(newUrl[0]);
          }
          if (this.href.split("/").length - 1 == 5) {
            urlLogin = decodeURIComponent(newUrlAnonymousLogin[0]);
            urlLogin = urlLogin.slice(0, urlLogin.length - 1);
          }
        } else {
          if (this.href.split("/").length - 1 == 3) {
            urlLogin = decodeURIComponent(newUrl[0]);
          }
          if (this.href.split("/").length - 1 == 4) {
            urlLogin = decodeURIComponent(newUrlAnonymousLogin[0]);
            urlLogin = urlLogin.slice(0, urlLogin.length - 1);
          }
        }
      } else {
        if (newUrlAnonymousLogin.length > 0) {
          urlLogin = decodeURIComponent(newUrlAnonymousLogin[0]);
          urlLogin = urlLogin.slice(0, urlLogin.length - 1);
        }
      }
      this.router.navigate([urlLogin]);
    } else if (this.href.includes(Routes.ENTERPRISE_KYC)) {
      if (
        this.href.split("/")[4] &&
        (urlKYCCustom || urlKYCCustom || urlKYCCamera || urlKYCSign || urlKYC)
      ) {
        this.router.navigate([
          "/sign-anonymous" +
            "/" +
            this.href.split("/")[2] +
            "/" +
            this.href.split("/")[3] +
            "/" +
            this.href.split("/")[4],
        ]);
      } else {
        this.router.navigate(["enterprise-login"]).then(() => {
          this.auth.logout();
        });
      }
    } else if (this.href.includes("identification-method")) {
      if (urlKYCIentifi.length) {
        const urlDecode = decodeURIComponent(urlKYCIentifi.input);
        const urlDecodeNew = urlDecode.replace(
          "identification-method",
          "sign-anonymous"
        );
        this.router.navigate([urlDecodeNew]);
      } else {
        this.router.navigate(["enterprise-login"]).then(() => {
          this.auth.logout();
        });
      }
    }
  }
}
